import { render, staticRenderFns } from "./CollectionContentModal.vue?vue&type=template&id=744b7b6e&scoped=true"
import script from "./CollectionContentModal.vue?vue&type=script&lang=js"
export * from "./CollectionContentModal.vue?vue&type=script&lang=js"
import style0 from "../../../../../node_modules/vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./CollectionContentModal.vue?vue&type=style&index=1&id=744b7b6e&prod&scoped=true&lang=css"
import style2 from "./CollectionContentModal.vue?vue&type=style&index=2&id=744b7b6e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "744b7b6e",
  null
  
)

export default component.exports